import { render, staticRenderFns } from "./tableInfo.vue?vue&type=template&id=7cbdda72&"
import script from "./tableInfo.vue?vue&type=script&lang=js&"
export * from "./tableInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports